<template>
  <div class="page tcenter">
    <template v-for="count in totalPage">
      <a class="trans3 dinline-block" v-if="count==1" :class="{disabled:pagen==1}" @click="goPre()">&lt;</a>
      <a class="trans3 dinline-block" v-if="count==1 || (count > pagen - 2 && count < pagen + 2) || count==totalPage" :class="{active:pagen==count}" @click="goPage(count)">{{count}}</a>
      <span class="ey ml10 mr10" v-else-if="count == pagen - 2 || count == pagen + 2">...</span>
      <template v-else/>
      <a class="trans3 dinline-block" v-if="count==totalPage" :class="{disabled:pagen==totalPage}" @click="goNext()">&gt;</a>
    </template>
  </div>
</template>

<script>
export default {
  name: "Page",
  data () {
    return {
      totalPage:0,
      pagen:0,
    }
  },
  props:[
    'page',
    'total',
    'size',
  ],
  created() {
    this.pagen = parseInt(this.page);
  },
  mounted() {
    this.totalPage = Math.ceil(this.total / this.size);//总页数
  },
  methods:{
    goPage(page){
      this.pagen = page;
    },
    goNext(){
      if(this.pagen < this.totalPage){
        this.pagen ++;
      }

    },
    goPre(){
      if(this.pagen > 1){
        this.pagen --;
      }
    }
  },
  watch: {
    pagen:{
      handler: function(value,oldValue) {
        this.$emit('get-data', value)
      }
    },
    total:{
      handler:function (n,o) {
        this.totalPage = Math.ceil(n / this.size);//总页数
        this.pagen = 1;
      }
    }
  },
}
</script>

<style scoped>
  .page{padding: 50px 0;}
  .page .active{color: #fff;}
  .page a{width: 44px;height: 44px;line-height: 42px;color: #888;border: 1px solid #e2e2e2;border-left-width: 1px;border-radius: 3px;}
  .page .active,.page a:hover:not(.disabled){background: #3d9c94;border-color: #3d9c94;color: #fff;}
</style>



// WEBPACK FOOTER //
// src/components/un_index/Page.vue